import { render, staticRenderFns } from "./UiCompactSectionCard.vue?vue&type=template&id=74d559d2&scoped=true"
import script from "./UiCompactSectionCard.vue?vue&type=script&lang=js"
export * from "./UiCompactSectionCard.vue?vue&type=script&lang=js"
import style0 from "./UiCompactSectionCard.vue?vue&type=style&index=0&id=74d559d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d559d2",
  null
  
)

export default component.exports